import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search.js";
import InputAdornment from "@mui/material/InputAdornment/index.js";
import Typography from "@mui/material/Typography/index.js";
import { useDebouncedCallback } from "use-debounce";
import { InvoiceStatus } from "../../no-show-fee-list.types.js";
import { useLabels } from "../../providers/labels.provider.js";
import { useNoShowFilters } from "../../providers/no-show-filters-provider.js";
import NoShowFeeFilterPopover from "../NoShowFeeFilterPopover/NoShowFeeFilterPopover.js";
import { StyledToolbar, ToolbarLeftSection, Switch, SwitchOption, SearchField, StyledFilterIcon } from "./NoShowFeeToolbar.styles.js";
import "@mui/icons-material/Close.js";
import "@mui/material/Box/index.js";
import "@mui/material/Button/index.js";
import "@mui/material/Checkbox/index.js";
import "@mui/material/FormControlLabel/index.js";
import "@mui/material/IconButton/index.js";
import "@mui/material/Stack/index.js";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "@mui/material";
import "../../../../../themes/typography/typography.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "@mui/system";
import "../../../../../components/date-pickers/date-picker/date-picker.js";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../../../type/Translations.js";
import "date-fns/locale";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "@mui/material/styles";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "../../../../../components/slider/slider.styles.js";
import "../../../../../components/snackbar/snackbar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "../../../../../components/translations/utils.js";
import "react-i18next";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "../../../../../components/time-select/time-select.styles.js";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import "../NoShowFeeFilterPopover/NoShowFeeFilterPopover.styles.js";
import "@mui/material/Popover/index.js";
import "@mui/material/Toolbar/index.js";
const NoShowFeeToolbar = () => {
  var _a;
  const { labels } = useLabels();
  const { appliedFilters, setAppliedFilters } = useNoShowFilters();
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [searchValue, setSearchValue] = useState();
  const searchInputRef = useRef(null);
  const debouncedSetSearchTerm = useDebouncedCallback((value) => {
    setAppliedFilters({ ...appliedFilters, searchTerm: value });
  }, 300);
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    debouncedSetSearchTerm(value);
  };
  const handleFilterClick = () => {
    setFilterAnchorEl(searchInputRef.current);
  };
  const closeFilterPopover = () => {
    setFilterAnchorEl(null);
  };
  const handleStatusSwitch = (status) => {
    setAppliedFilters({ ...appliedFilters, status: [status] });
  };
  const showCancelled = Boolean((_a = appliedFilters.status) == null ? void 0 : _a.includes(InvoiceStatus.CANCELLED));
  return /* @__PURE__ */ jsxs(StyledToolbar, { children: [
    /* @__PURE__ */ jsxs(ToolbarLeftSection, { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "Lato H5 Bold", children: labels.toolbar.title }),
      /* @__PURE__ */ jsxs(Switch, { children: [
        /* @__PURE__ */ jsx(SwitchOption, { isSelected: !showCancelled, onClick: () => handleStatusSwitch(InvoiceStatus.OPEN), children: labels.toolbar.showAll }),
        /* @__PURE__ */ jsx(SwitchOption, { isSelected: showCancelled, onClick: () => handleStatusSwitch(InvoiceStatus.CANCELLED), children: labels.toolbar.showFreed })
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      SearchField,
      {
        ref: searchInputRef,
        size: "small",
        placeholder: labels.toolbar.searchPlaceholder,
        value: searchValue ?? appliedFilters.searchTerm,
        onChange: handleSearchChange,
        InputProps: {
          startAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(SearchIcon, {}) }),
          endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", onClick: handleFilterClick, children: /* @__PURE__ */ jsx(StyledFilterIcon, {}) })
        }
      }
    ),
    Boolean(filterAnchorEl) && /* @__PURE__ */ jsx(
      NoShowFeeFilterPopover,
      {
        isOpen: Boolean(filterAnchorEl),
        anchorEl: filterAnchorEl,
        onClose: closeFilterPopover
      }
    )
  ] });
};
export {
  NoShowFeeToolbar as default
};
